import React from 'react';
import { useDispatch } from 'react-redux';
import Button from '@material-ui/core/Button';
import stylesParent from '../../styles/frame/frame.module.scss';
import Header from '../../../../../../components/Stake/header';
import RfuelIcon from '../../../../../../assets/images/tokens/rfuel.svg';
import * as rfuelStakeActions from '../../../../../../actions/rfuel-stake-actions';
import ContentError from '../../../../../../components/content-error';

const Error = () => {
  const dispatch = useDispatch();

  return (
    <>
      <Header icon={RfuelIcon} title='RFUEL Error' />
      <div className={stylesParent.cardContent}>
        <ContentError
          title='An unexpected error has occured, please try again later.'
          className={stylesParent.error}
        >
          If the issue still persists, contact us in{' '}
          <a href='https://t.me/MANTRADAO' rel='noopener noreferrer' target='_blank'>
            Telegram
          </a>{' '}
          or send us an email at <a href='mailto:support@mantradao.com'>support@mantradao.com</a>{' '}
          with the relevant info about the issue.
        </ContentError>
        <Button
          variant='contained'
          onClick={() => dispatch(rfuelStakeActions.stakeReset())}
          className={stylesParent.cardFooterControlsButton}
          color='secondary'
        >
          <span style={{ fontWeight: 800 }}>Done</span>
        </Button>
      </div>
    </>
  );
};

export default Error;
